import { defineComponent as _defineComponent } from 'vue'
import {computed, onMounted, onUnmounted, ref} from 'vue';
import useClickOutside from '@/composables/useClickOutside';
import PopupContainer from "@/components/popup.vue";
import toolTip from '@/components/tool-tip.vue';

import { Builders } from '@busy-human/hxp-library';

import SaveBuilderWarning from '@/components/saveBuilderWarning.vue';
import BuilderAlreadyExists from "@/components/builderExistsPopup.vue";

import { useShoppingBuilderStore } from '@/store/builder-shopping';
import { useZohoStrings } from "@/store/zohoStrings";

type Props = {
	selectedTeenName?: string
	selectedTeenId?: string
	disableTeenSelect?: boolean
}
type Emits = {
	(e: 'createNewTeen'): void
	(e: 'saveParent', parent: Partial<Builders.Model>): void
	(e: 'close'): void
}

export default /*#__PURE__*/_defineComponent({
  __name: 'add-parent-builder',
  props: {
    selectedTeenName: {},
    selectedTeenId: {},
    disableTeenSelect: { type: Boolean }
  },
  emits: ["createNewTeen", "saveParent", "close"],
  setup(__props: any, { expose: __expose, emit: __emit }) {
  __expose();

const builderStore = useShoppingBuilderStore();
const zohoStrings = useZohoStrings();


const props = __props;

const emit = __emit;

const whatIsAParentTitleHtml = computed(() => zohoStrings.strings?.zh_parentBuilderNoteTitle?.rendered || 'What is a Parent Builder?');
const whatIsAParentSubTitleHtml = computed(() => zohoStrings.strings?.zh_parentBuilderNoteSubtitle?.rendered || 'And why do teens with a Parent Builder get their preferred trips?');
const whatIsAParentBodyHtml = computed(() => zohoStrings.strings?.zh_parentBuilderNoteDescription?.rendered || '');

const showBuilderExists = ref(false);
const showBuilderSaveWarning = ref(false);

const workingParentBuilder = ref<Partial<Builders.Model>>({...Builders.Default(), builderType: Builders.BuilderType.ParentBuilder, gender: undefined});

const parentBuilderFor = ref<boolean | string | null>(!!props.selectedTeenName || props.selectedTeenId || null);

const availableTeens = computed(() => builderStore.asArray.filter((builder) => builderStore.validateTeenBirthday(builder.birthday) === 'valid' && !builderStore.selectedBuilderRecord?.builderTypeDetails.pairUser));

const parentBuilderBirthday = computed({
	get() {
		if(!workingParentBuilder.value?.birthday) return undefined;
		return workingParentBuilder.value.birthday;
	},
	set(val) {
		if(!val) {delete workingParentBuilder.value?.birthday;}
		else {
			const tmp = new Date(val);
			if(tmp instanceof Date && !isNaN(tmp.valueOf())) {
				workingParentBuilder.value.birthday = Builders.dateToBirthdate(tmp);
			}
		}
	}
});

function checkIfBuilderExists(){
	let builderExists = false;
	let builderHasSameName = false;
	builderStore.selectableGroups.forEach(group =>{
		const parentBuilderId = group.parent;
		if(!parentBuilderId) return;
		const parentBuilder = builderStore.builders[parentBuilderId];
		if(workingParentBuilder.value.name && workingParentBuilder.value.birthday){
			if(workingParentBuilder.value.name.firstName === parentBuilder.name.firstName && workingParentBuilder.value.name.lastName === parentBuilder.name.lastName && workingParentBuilder.value.birthday === parentBuilder.birthday){
				builderExists = true;
			}else if(parentBuilder.name.firstName === workingParentBuilder.value.name.firstName){
				builderHasSameName = true;
			}

		}
	});
	if(builderExists){
		return "builderExists";
	}else if(builderHasSameName){
		return "builderHasSameName";
	}else{
		return "valid";
	}
}

function doSaveParent() {
	const builderExists = checkIfBuilderExists();
	if(builderExists === 'builderExists'){
		showBuilderExists.value = true;
	}else if(builderExists === 'builderHasSameName'){
		showBuilderSaveWarning.value = true;
	}else{
		emit('saveParent', workingParentBuilder.value);
	}
}

const parentBirthdayValid = computed<'valid' | 'tooYoung' | 'invalid'>(() => {
	if(!parentBuilderBirthday.value) return 'invalid';

	const builderAge = Builders.GetBuilderAge(parentBuilderBirthday.value);

	if(builderAge < (Builders.MinimumAgeForAdult-1) ) return 'tooYoung';

	return 'valid';
});



//TODO: Change Select into popup to fit designs
const handleTeenSelect = () => {
	// e.preventDefault()
};

const showDropdown = ref(false);
const teenSelect = ref(null);
useClickOutside(teenSelect, ()=> {
	if(showDropdown.value)
	{showDropdown.value = false;}
});

const isBoxScrollable = ref(false);
const builderDetailsElement = ref<HTMLElement | null>(null);
function checkDetailsScrollable() {
	if(!builderDetailsElement.value) {
		isBoxScrollable.value = false;
		return;
	}

	const el = builderDetailsElement.value;
	const canScroll = el.scrollHeight > el.clientHeight;
	const CLOSEDIST = 5;
	const scrolledDown = el.scrollTop > ((el.scrollHeight - el.offsetHeight) - CLOSEDIST);
	isBoxScrollable.value = (canScroll && !scrolledDown);
}
onMounted(() => {
	checkDetailsScrollable();
	window.addEventListener('resize', checkDetailsScrollable);
	parentBuilderFor.value = !!props.selectedTeenName || props.selectedTeenId || null;
});
onUnmounted(() => {
	window.removeEventListener('resize', checkDetailsScrollable);
});



const __returned__ = { builderStore, zohoStrings, props, emit, whatIsAParentTitleHtml, whatIsAParentSubTitleHtml, whatIsAParentBodyHtml, showBuilderExists, showBuilderSaveWarning, workingParentBuilder, parentBuilderFor, availableTeens, parentBuilderBirthday, checkIfBuilderExists, doSaveParent, parentBirthdayValid, handleTeenSelect, showDropdown, teenSelect, isBoxScrollable, builderDetailsElement, checkDetailsScrollable, computed, onMounted, onUnmounted, ref, get useClickOutside() { return useClickOutside }, PopupContainer, toolTip, get Builders() { return Builders }, SaveBuilderWarning, BuilderAlreadyExists, get useShoppingBuilderStore() { return useShoppingBuilderStore }, get useZohoStrings() { return useZohoStrings } }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})